import {
    BottomNavigation,
    BottomNavigationAction,
    Box,
    Container,
    Grid,
    Paper,
    Typography,
    useTheme,
} from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../api/authApiSlice';
import { bottomExternalTabs, filterReducers } from '../../store/local/contents';
import { setUser } from '../../store/slices/authSlice';
import { appUpdateVersion } from '../../utils/config';
import KanisaHeader from '../ui/KanisaHeader';
import ListLoading from './ListLoading';

export default function ExternalScreen({
    children,
    title,
    tab,
    authPass,
    controls,
    disableBackButton,
    disableAppBar,
    disablePadding,
    disableSpacing,
    backAction,
    loading,
}) {
    const navigate = useNavigate();
    const theme = useTheme();
    const body = useRef(null);

    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { user } = state.auth;

    const [value, setValue] = React.useState(0);

    const onboard = localStorage.getItem(appUpdateVersion);
    const [logout] = useLogoutMutation();

    useEffect(() => {
        filterReducers?.map((reducer) => {
            if (
                state[reducer] &&
                state[reducer]?.err &&
                state[reducer]?.err?.message?.search('Unauthenticated') !== -1
            ) {
                logout();
                dispatch(setUser({}));
            }
            return null;
        });
    }, [dispatch, logout, state]);

    useEffect(() => {
        const currentNavId = bottomExternalTabs?.filter(
            (tabItem) => tabItem.link === window.location.pathname
        )[0]?.id;

        !onboard && navigate('/onboarder');

        setValue(currentNavId);
    }, [navigate, onboard]);

    if (JSON.stringify(user) != '{}' || authPass) {
        return (
            <Paper
                sx={{
                    minHeight: '100vh',
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 0,
                }}
                elevation={0}
            >
                <Container
                    maxWidth="sm"
                    className={disablePadding && 'px-0'}
                    style={{
                        backgroundColor: theme.palette.background.default,
                        paddingTop: !disableAppBar && 56,
                    }}
                >
                    {!disableAppBar && (
                        <KanisaHeader
                            tab={tab}
                            title={title}
                            authPass={authPass}
                            controls={controls}
                            disableBackButton={disableBackButton}
                            backAction={backAction}
                            loading={loading}
                        />
                    )}
                    {!disablePadding && (
                        <Box sx={{ width: '100%', height: 16 }} />
                    )}
                    <Grid
                        ref={body}
                        style={{ paddingBottom: tab ? 70 : 30 }}
                        spacing={!disableSpacing ? 1 : 0}
                        container
                    >
                        {children}
                    </Grid>
                    {tab && (
                        <BottomNavigation
                            value={value}
                            showLabels
                            className="w-100"
                            sx={{
                                borderTop: 1,
                                borderTopColor: 'divider',
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                zIndex: 2,
                            }}
                        >
                            {bottomExternalTabs.map((tabItem) => {
                                return (
                                    <BottomNavigationAction
                                        key={`${tabItem.link}`}
                                        onClick={() => {
                                            navigate(tabItem.link);
                                            setValue(tabItem.id);
                                        }}
                                        label={
                                            <Typography
                                                variant="body2"
                                                component="span"
                                            >
                                                {tabItem.label}
                                            </Typography>
                                        }
                                        icon={
                                            window.location.pathname ===
                                            tabItem.link
                                                ? tabItem.iconActive
                                                : tabItem.iconInactive
                                        }
                                    />
                                );
                            })}
                        </BottomNavigation>
                    )}
                </Container>
            </Paper>
        );
    }

    return <ListLoading />;
}
